<div>
    <div *nzModalTitle>
        {{ 'relation-relation.modal.add-title' | translate }}
    </div>
    <form nz-form [formGroup]="formGroup">
        <section class="form-section">
            <header>
                <h5 class="form-section__title">
                    {{ 'activity-relation.modal.header.application' | translate }}
                </h5>
            </header>
            <div nz-row>
                <div nz-col [nzSpan]="12">
                    <div nz-col nzSpan="24" style="display: flex">
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24">
                                {{ 'relation-relation.fields.relation-name' | translate }}
                            </nz-form-label>
                        <div>
                            <div>{{ relationName | truncateText }}&nbsp;</div>
                        </div>
                        </nz-form-item>
                    </div>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzRequired [nzSpan]="24">
                            {{ 'relation-relation.fields.relation-type' | translate }}
                        </nz-form-label>
                        <nz-form-control [nzSpan]="24" [nzErrorTip]="relationshipTypeValidationTemplate">
                            <nz-select
                                class="w-100"
                                nzPlaceHolder="{{ 'relation-relation.placeholder.relation-type' | translate }}"
                                formControlName="relationshipType"
                                (ngModelChange)="
                                    this.formGroup.controls.relatedRelationshipType.setValue(
                                        this.relationshipTypeOpposites[this.formGroup.controls.relationshipType.value]
                                    )
                                ">
                                <nz-option
                                    *ngFor="let relationType of (relationshipTypes | enumKeyValue) | slice:1"
                                    [nzLabel]="relationshipTypeLabels[relationType.value] | translate"
                                    [nzValue]="relationType.value"></nz-option>
                            </nz-select>
                            <ng-template #relationshipTypeValidationTemplate let-control>
                                <app-input-validation
                                    [control]="control"
                                    [field]="'relationshipType'"
                                    [errors]="errors"></app-input-validation>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>

            <div nz-row>
                <div nz-col [nzSpan]="12">
                    <app-relation-relation-dropdown
                        [parent]="formGroup"
                        [relationList]="relations$ | async"
                        (search)="searchEmitterSearch($event)" />
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="24">
                            {{ 'relation-relation.fields.related-relation-type' | translate }}
                        </nz-form-label>
                        <nz-form-control [nzSpan]="24">
                            <nz-select
                                class="w-100"
                                nzPlaceHolder="{{ 'relation-relation.placeholder.relation-type' | translate }}"
                                formControlName="relatedRelationshipType">
                                <nz-option
                                    *ngFor="let relationType of relationshipTypes | enumKeyValue"
                                    [nzLabel]="relationshipTypeLabels[relationType.value] | translate"
                                    [nzValue]="relationType.value"></nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </section>
    </form>

    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="destroyModal()">{{ 'common.cancel' | translate }}</button>
        <button nz-button nzType="primary" (click)="submit()">{{ 'common.add' | translate }}</button>
    </div>
</div>
